import React, { useRef, useState } from 'react'
import { Modal, Button, TextField, Banner } from '@ui'

export function InviteModal({ onClose, onSubmit }) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [team, setTeam] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const emailRef = useRef(null)

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      await onSubmit({ email, name, team: team || undefined })
      onClose()
    } catch (err) {
      setError(err.message || 'Failed to invite user.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal open onClose={onClose} title="Invite user" width="sm" initialFocusRef={emailRef}>
      {error ? <Banner tone="error">{error}</Banner> : null}
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
        <TextField
          ref={emailRef}
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Display name (optional)"
        />
        <TextField
          label="Team"
          value={team}
          onChange={(e) => setTeam(e.target.value)}
          placeholder="e.g. Engineering"
        />
        <div className="modal__actions">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" loading={loading} loadingLabel="Sending…">Send invitation</Button>
        </div>
      </form>
    </Modal>
  )
}
